<template>
  <div class="vx-row" id="gallery">
    <div class="vx-col lg:w-3/4 w-full relative">
      <vs-table
        :data="basketImageForShow"
        id="gallery-tbl"
        ref="table"
        v-if="loadTable"
      >
        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th class="img-col">{{ $t("Image") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
            <vs-td class="index-td" :data="data[indextr]" style="width: 6%">
              {{ parseInt(indextr) + 1 }}
            </vs-td>
            <vs-td
              class="image-td"
              :data="data[indextr].documentContent"
              style="width: 94%"
            >
              <span v-if="data[indextr].type == 2" style="font-size: 2rem">
                <a
                  class="ma-2"
                  outlined
                  :href="defaultUrl + data[indextr].uri"
                  download
                >
                  <i class="material-icons" style="font-size: 7rem">
                    description
                  </i>
                </a>
              </span>

              <img
                v-else
                :src="defaultUrl + data[indextr].uri"
                @click.prevent="imgPopup(tr)"
              />
              <vs-button
                radius
                color="danger"
                size="small"
                type="gradient"
                icon-pack="feather"
                icon="icon-x"
                @click="removeImage(tr.name)"
                class="d-inline remove-img-btn"
              ></vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <image-popup
        :show="onImagePopup"
        @finish="onfinish"
        :model="modalModel"
        id="gal-popup"
      ></image-popup>
      <div class="loadingsec" v-if="showLoading">
        <svg
          class="spinner"
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
    </div>

    <div class="vx-col lg:w-1/4 w-full">
      <vx-card>
        <vue-upload-multiple-image
          @upload-success="uploadImageSuccess"
          :data-images="uploadingImage"
          :maxImage="1"
          :dragText="$t('DragAndDrop')"
          :browseText="$t('UploadFile')"
          :showEdit="false"
          :showDelete="false"
          :showPrimary="false"
        ></vue-upload-multiple-image>
      </vx-card>
    </div>
  </div>
</template>
<style lang="scss">
#gal-popup .vs-popup--content {
  overflow-y: scroll !important;
}
#gallery .vs-table--tbody-table .tr-values td {
  position: relative;
}
.loadingsec {
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapGetters, mapActions } from "vuex";
import ImagePopup from "./ImagePopup.vue";
import VueUploadMultipleImage from "vue-upload-multiple-image";

export default {
  name: "basketManagement_ChannelBaskets_FilesAndAttachments",
  data() {
    return {
      defaultUrl: URLS_CONSTANTS.assets + "Baskets/",
      basketImage: {},
      basketImageForShow: [],
      basketImageModel: {},
      uploadingImage: [],
      show: false,
      onImagePopup: false,
      modalModel: {},
      showLoading: true,
      loadTable: false,
    };
  },
  components: {
    ImagePopup,
    VueUploadMultipleImage,
  },
  computed: {
    ...mapGetters({
      saleAgentBasketImages: "basket/saleAgentBasketImagesDetails",
    }),
    popupActive: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchSaleAgentBasketImages: "basket/fetchSaleAgentBasketImages",
      postImage: "basket/saleAgentBasketAddImage",
      deleteImage: "basket/saleAgentBasketRemoveImage",
    }),
    load() {
      this.basketImageForShow = [];
      var id = this.$route.params.id;
      this.basketImage = {};
      this.fetchSaleAgentBasketImages(id).then(() => {
        this.basketImage = JSON.parse(
          JSON.stringify(this.saleAgentBasketImages)
        );
        this.basketImage.forEach((element) => {
          this.basketImageForShow.push({
            name: element.name,
            uri: element.uri,
            type: element.name.split(".")[1] == "xlsx" ? "2" : "1",
          });
        });

        if (this.showLoading) {
          setTimeout(() => {
            this.showLoading = false;
            this.loadTable = true;
          }, 1000);
        }
      });
    },
    uploadImageSuccess(formData, index, fileList) {
      this.basketImageModel = {
        basketId: this.$route.params.id,
        documentContent: fileList[index].path,
      };
      if (fileList[index].name.split(".")[1] == "xlsx") {
        this.basketImageModel.documentType = 2;
      } else {
        this.basketImageModel.documentType = 1;
      }
      this.postImage(this.basketImageModel).then(() => {
        this.basketImageModel.documentContent = "";
        this.documentContent = "";
        this.loadTable = false;
        this.showLoading = true;
        setTimeout(() => {
          this.load();
          this.uploadingImage = [];
        }, 1500);
      });
    },
    removeImage(name) {
      var basketId = this.$route.params.id;
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.deleteImage({ basketId, name }).then(() => {
            this.loadTable = false;
            this.showLoading = true;
            setTimeout(() => {
              this.load();
            }, 1500);
          });
        }
      });
    },
    imgPopup(model) {
      this.onImagePopup = true;
      this.modalModel = model.uri;
    },
    onfinish() {
      this.onImagePopup = false;
    },
  },
};
</script>
